// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import {
  createProject,
  updateProject,
  fetchResellerTree,
  fetchDistributerTree
} from "../../actions/projectActions";
import { fetchAdminResellerTree } from "../../../admin/actions/projectAdminActions";
import { createCompany } from "../../actions/companyActions";
import { TextareaMultilLines } from "../../../global/functions/MultilLineStrings";
import { DatabaseDateToJsDateISOString } from "../../../global/functions/DateTimeAmend";
import { AusStates } from "../../../global/types/AusStates";
import { LoadingProgress } from "imagus-components";
import EditProjectForm from "../../components/projects/EditProjectForm";
import CreateProjectForm from "../../components/projects/CreateProjectForm";

type CreateProjectFormReduxPropsType = {
  onClose: Function,
  openSnackbar: Function,
  project?: { [key: string]: * },
  isAdmin?: boolean,
  isEdit?: boolean,
  tree: Array<*>,
  adminTree: Array<*>,
  distributerTree: Array<*>,
  userCompany: { [key: string]: * },
  actions: {
    createProject: Function,
    updateProject: Function,
    fetchResellerTree: Function,
    fetchAdminResellerTree: Function,
    createCompany: Function,
    fetchDistributerTree: Function
  }
};

class CreateProjectFormRedux extends Component<
  CreateProjectFormReduxPropsType,
  *
> {
  componentDidMount() {
    if (this.props.isAdmin) {
      if (this.props.adminTree === null) {
        this.props.actions.fetchAdminResellerTree();
      }
    } else {
      if (this.props.tree === null) {
        this.props.actions.fetchResellerTree();
      }
      if (this.props.distributerTree === null) {
        this.props.actions.fetchDistributerTree();
      }
    }
  }

  createProject = (
    project_name: string,
    closeDate: string,
    notes: string,
    camera_count: string,
    face_count: string,
    address: string,
    suburb: string,
    city: string,
    state: string,
    country: string,
    postcode: string,
    reseller_id: string,
    enduser_id: string,
    shouldUpdateResellerTree: boolean,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.createProject(
      project_name,
      closeDate,
      notes,
      camera_count,
      face_count,
      address,
      suburb,
      city,
      state,
      country,
      postcode,
      reseller_id,
      enduser_id,
      shouldUpdateResellerTree,
      doneCallback,
      failCallBack
    );
  };

  updateProject = (
    project_name: string,
    closeDate: string,
    notes: string,
    camera_count: string,
    face_count: string,
    address: string,
    suburb: string,
    city: string,
    state: string,
    country: string,
    postcode: string,
    reseller_id: string,
    enduser_id: string,
    doneCallback: Function,
    failCallBack: Function
  ): * => {
    this.props.actions.updateProject(
      this.props.project.id,
      project_name,
      closeDate,
      notes,
      camera_count,
      face_count,
      address,
      suburb,
      city,
      state,
      country,
      postcode,
      reseller_id,
      enduser_id,
      doneCallback,
      failCallBack,
      this.props.isAdmin
    );
  };

  createCompany = (
    contactNumber: string,
    companyName: string,
    notes: string,
    abn: string,
    parentId: string,
    contactEmail: string,
    postcode: string,
    contactName: string,
    city: string,
    country: string,
    state: string,
    suburb: string,
    address: string,
    doneCallback: Function,
    failCallBack: Function,
    authorisedReseller: boolean,
    companyType: string
  ): * => {
    this.props.actions.createCompany(
      contactNumber,
      companyName,
      notes,
      abn,
      parentId,
      contactEmail,
      postcode,
      contactName,
      city,
      country,
      state,
      suburb,
      address,
      doneCallback,
      failCallBack,
      false,
      authorisedReseller,
      companyType,
      "",
      "",
      "",
      "",
      true
    );
  };

  getResellerTree = (): * => {
    let tree = null;
    if (this.props.isAdmin) {
      let createdCompany = this.props.project.createdCompany;
      if (createdCompany.companyType === "RESELLER") {
        if (this.props.adminTree) {
          for (let node of this.props.adminTree) {
            for (let reseller of node.resellers) {
              if (reseller.id == createdCompany.id) {
                tree = [reseller];
                break;
              }
            }
          }
        }
      } else {
        tree =
          this.props.adminTree &&
          this.props.adminTree.filter(
            tree => tree.parent.id === createdCompany.id
          )[0].resellers;
      }
    } else {
      tree = this.props.tree && [...this.props.tree];
    }
    return tree;
  };

  updateEndUserList = (resellerId: string): * => {
    let reseller = null;
    let end_user_list = null;

    const resellerTree = this.getResellerTree();
    if (resellerTree) {
      let index = resellerTree.findIndex(x => x.id === resellerId);
      if (index > -1) {
        reseller = resellerTree[index];
        end_user_list = reseller.children.edges.map(
          (company: *): * => ({
            value: company.node.id,
            label: company.node.name
          })
        );
      }
    }

    return [reseller, end_user_list];
  };

  render(): React$Element<*> {
    const initialForm = {};
    let ResellerCompanyList = [];
    let DistributerList = [];
    let forReseller = false;
    const project = this.props.project;
    const resellerTree = this.getResellerTree();

    if (resellerTree) {
      ResellerCompanyList = resellerTree.map(
        (company: *): * => ({
          value: company.id,
          label: company.name
        })
      );

      if (project) {
        initialForm.project_name = project.project_name;
        initialForm.face_count = project.noOfFaces;
        initialForm.camera_count = project.noOfStreams;
        initialForm.notes = TextareaMultilLines(project.notes) || "";

        initialForm.expiry_date = DatabaseDateToJsDateISOString(
          project.closeDateOrigin
        );

        initialForm.address = project.address;
        initialForm.suburb = project.suburb;
        initialForm.city = project.city;
        initialForm.country = project.country;
        initialForm.postcode = project.postcode;

        const state = project.state || "";
        let index = AusStates.findIndex(x => x.value === state);
        if (index < 0 && state !== "") {
          initialForm.state = "Other";
          initialForm.other_state = state;
        } else {
          initialForm.state = state;
        }

        if (project.resellerCompany) {
          initialForm.reseller_id = project.resellerCompany.id;
          let index2 = resellerTree.findIndex(
            x => x.id === project.resellerCompany.id
          );
          if (index2 > -1) {
            const reseller = resellerTree[index2];
            const end_user_list = reseller.children.edges.map(
              (company: *): * => ({
                value: company.node.id,
                label: company.node.name
              })
            );
            initialForm.reseller = reseller;
            initialForm.end_user_list = end_user_list;

            if (project.enduserCompany) {
              initialForm.enduser_id = project.enduserCompany.id;
              const children = reseller.children.edges;
              let index = children.findIndex(
                x => x.node.id === project.enduserCompany.id
              );
              initialForm.end_user = children[index].node;
            }
          }
        }
      } else {
        if (this.props.userCompany.companyType === "RESELLER") {
          let index2 = resellerTree.findIndex(
            x => x.id === this.props.userCompany.id
          );
          if (index2 > -1) {
            const reseller = resellerTree[index2];
            const end_user_list = reseller.children.edges.map(
              (company: *): * => ({
                value: company.node.id,
                label: company.node.name
              })
            );
            initialForm.resellerId = reseller.id;
            initialForm.reseller = reseller;
            initialForm.endUserList = end_user_list;
            forReseller = true;
          }
        } else if (
          this.props.userCompany.companyType === "DISTRIBUTER" ||
          this.props.userCompany.companyType === "TOPLEVEL"
        ) {
          if (
            this.props.distributerTree &&
            this.props.distributerTree.length === 1
          ) {
            // direct distributer
            initialForm.distributerId = this.props.distributerTree[0].id;
          } else {
            DistributerList =
              this.props.distributerTree &&
              this.props.distributerTree.map(
                (company: *): * => ({
                  value: company.id,
                  label: company.name
                })
              );
          }
        }
      }
    }

    const IsDisabledEndUserChange =
      this.props.project && this.props.project.licence.length > 0
        ? true
        : false;

    if (!resellerTree || !initialForm) {
      return <LoadingProgress />;
    } else if (this.props.isEdit) {
      return (
        <EditProjectForm
          onClose={this.props.onClose}
          openSnackbar={this.props.openSnackbar}
          initialForm={initialForm}
          isEdit
          ResellerCompanyList={ResellerCompanyList}
          IsDisabledEndUserChange={IsDisabledEndUserChange}
          updateEndUserList={this.updateEndUserList}
          updateProject={this.updateProject}
        />
      );
    } else {
      return (
        <CreateProjectForm
          onClose={this.props.onClose}
          DistributerList={DistributerList}
          ResellerCompanyList={ResellerCompanyList}
          updateEndUserList={this.updateEndUserList}
          createProject={this.createProject}
          createCompany={this.createCompany}
          initialForm={initialForm}
          forReseller={forReseller}
        />
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  tree: state.v3account.project.resellerTree,
  adminTree: state.v3admin.project.resellerTree,
  distributerTree: state.v3account.project.distributerTree,
  userCompany: state.v3account.user.company
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators(
    {
      createProject,
      updateProject,
      fetchResellerTree,
      fetchAdminResellerTree,
      createCompany,
      fetchDistributerTree
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateProjectFormRedux);
